import { render } from "./clsBtn.vue?vue&type=template&id=c04b2d04&scoped=true"
import script from "./clsBtn.vue?vue&type=script&lang=js"
export * from "./clsBtn.vue?vue&type=script&lang=js"

import "./clsBtn.vue?vue&type=style&index=0&id=c04b2d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04b2d04"]])

export default __exports__